<a (click)="uploadFileAbbruch()" class="mini-button" mat-button>Abbrechen</a>

<div class="div_after_middle">
  <div class="mini_top">
    <div class="upload_ready_section">
      <label for="beschr">Name</label><span class="label-text"></span>
      <mat-form-field>
        <input id="beschr" matInput [(ngModel)]="newTeilpaket.beschreibung" type="text" minlength="5" maxlength="50" pattern="^[\-\wäöüÄÖÜß]*$"
               title="Keine Sonderzeichen oder Leerzeichen erlaubt! Paketname muss aus mindestens 5 Zeichen bestehen (maximale Länge: 50 Zeichen)!"
               (keyup)="changeDone('beschr')"
               (keydown.enter)="changeDone('beschr')">
      </mat-form-field>
      <br>
      <label for="vtnr">Vermittler-Nr.</label><span class="label-text"></span>
      <mat-form-field>
        <input id = "vtnr" matInput [(ngModel)]="newTeilpaket.vermittlernummer" type="text" pattern="^[1-9][0-9]{8}$"
               title="Vermittler-Nr. muss 9-stellig sein und darf nur aus Ziffern bestehen!"
               (keyup)="changeDone('vtnr')"
               (keydown.enter)="changeDone('vtnr')">
      </mat-form-field>
      <br>
      <div>
        <label for="file">Datei auswählen</label><span class="label-text"></span>
        Ausgewählte Datei: <i>{{newTeilpaket.dateiname}}</i>
      </div>
      <br>
    </div>
  </div>
</div>
